import React from 'react';
import { makeStyles } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import { FormControl, Select, units } from '@ha/dsl';
import MenuItem from 'ha/components/next/Menu/MenuItem';
import CURRENCIES from 'ha/constants/Currencies';

const useStyles = makeStyles(theme => ({
  container: {
    width: 46,
  },
  root: {
    paddingBottom: 0,
    fontSize: units.rem(0.875),
  },
  select: {
    '&&': {
      paddingRight: 0,
    },
    '&:focus': {
      background: 'none',
    },
    textDecoration: 'underline',
    paddingTop: 0,
  },
  icon: {
    fontSize: 22,
    color: theme.palette.grey[700],
    top: -2,
  },
  menuPaper: {
    maxHeight: '350px',
  },
}));

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const CurrencySelector: React.FC<Props> = ({ value, onChange }) => {
  const classes = useStyles();

  return (
    <FormControl className={classes.container}>
      <Select
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onChange(e.target.value)
        }
        disableUnderline
        data-test-locator="Currency Selector"
        MenuProps={{
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          classes: { paper: classes.menuPaper },
        }}
        classes={{
          root: classes.root,
          select: classes.select,
          icon: classes.icon,
        }}
        IconComponent={ArrowDropDownIcon}
      >
        {CURRENCIES.map(item => (
          <MenuItem
            key={item}
            value={item}
            data-test-locator={`currency selector ${item}`}
          >
            {item}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CurrencySelector;
